import React, { Fragment, useEffect, useRef, useState } from "react";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import { useSelector, useDispatch } from "react-redux";
import { bool } from "prop-types";
import { push } from "connected-react-router";
import { useParams } from "react-router-dom";
import { getTransactionNumber } from "util/thirdPayment";
import MainContainer from "pages/_components/MainContainer";
import { actions as thirdPaymentActions } from "reducers/thirdPayment";
import { actions as accountsActions } from "reducers/accounts";
import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import Loader from "pages/_components/Loader";
import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import Action from "pages/_components/Action";
import { actions as fileActions } from "reducers/files";
import { isIOS } from "react-device-detect";
import TitleColumns from "./_components/TitleColumns";
import VendorsLotPaymentsItem from "./_components/ItemRow";
import DataDetailThirdParties from "./_components/DataDetailThirdParties";

const references = {
    PP: "Proveedores",
    PH: "Haberes",
};

const formatPendingTx = (line) => ({
    creditCbu: line.cbu,
    accountType: line.productType,
    creditCuit: line.cuit,
    creditAmountQuantity: Number(line.creditAmountQuantity),
    creditAmountCurrency: line.currency,
    voucher: line.voucher,
    reference: line.motivo,
    referenc: line.referenc,
    status: "PENDING",
});

const DetaiThirdParties = ({ isDesktop }) => {
    const { fetching, fetchingDownload, filterThirdParties, transaction } = useSelector((state) => state.thirdPayment);
    const { transactionLines } = useSelector((state) => state.form);
    const isPending = transaction?.idTransactionStatus === "PENDING";
    let _transactions = isPending
        ? transactionLines?.list?.map((line) => formatPendingTx(line))
        : transactionLines?.list?.filter((line) => !!line.creditCuit);

    _transactions = _transactions.map((line) => {
        if (line.status === "PROCESSED") {
            return Object.assign(line, { transactionNumber: getTransactionNumber(line.extendedData, line.status) });
        }
        return line;
    });

    const needWindowing = _transactions.length > 300;

    const { user } = useSelector((state) => state.session);
    const { id } = useParams();
    const dispatch = useDispatch();
    const {
        user: { userId },
    } = useSelector((state) => state.session);
    const fileId = transaction?.file[0]?.fileId;
    const [pageNumber, setPageNumber] = useState(2);
    const isCancel = useRef(false);

    useEffect(() => {
        dispatch(thirdPaymentActions.getTransaction(id, true));
        dispatch(transactionLinesActions.clearTransactionLines());
        dispatch(
            transactionLinesActions.listTransactionLinesRequest({
                id,
                pageNumber: 1,
                ...filterThirdParties,
                status: "TODOS",
                fileId,
            }),
        );
        dispatch(accountsActions.listAccounts(userId));
        return () => {
            if (!isCancel.current) {
                dispatch(thirdPaymentActions.resetThirdPayment());
            }
        };
    }, []);

    useEffect(() => {
        if (isPending) {
            dispatch(fileActions.getFileContentsRequest(fileId, false, user?.userId));
        }
    }, [transaction?.idTransactionStatus]);

    const showMoreLogs = () => {
        dispatch(
            transactionLinesActions.listTransactionLinesRequest({
                id,
                pageNumber,
                status: "TODOS",
                fileId,
            }),
        );
        setPageNumber(pageNumber + 1);
    };

    if (fetching) {
        return <Loader />;
    }

    const paymentType = () => {
        const type = transaction?.typePayment;
        let typeLong;
        if (type === "PP") {
            typeLong = "Pago a proveedores";
        }
        if (type === "PH") {
            typeLong = "Pago de haberes";
        }
        return typeLong;
    };
    const handleClickDonload = () => {
        dispatch(thirdPaymentActions.downloadDocument(fileId));
    };

    const handleDownload = (type) => {
        const reference = references[transaction?.typePayment] || "";
        const transactions = transactionLines?.list.map((item) => ({
            accountType: item.accountType,
            cbu: item.creditCbu,
            creditAmountCurrency: item.creditAmountCurrency,
            creditAmountQuantity: item.creditAmountQuantity,
            cuit: item.creditCuit,
            errorCode: item.errorCode,
            errorCodeMsg: item.errorCodeMsg,
            idTransaction: item.idTransaction,
            lineNumber: item.lineNumber,
            motivo: item.reference,
            referenc: item.reference,
            reference,
            status: item.status,
            statusDate: item.statusDate,
            voucher: item.voucher,
            transactionNumber: getTransactionNumber(item.extendedData, item.status),
        }));
        dispatch(
            thirdPaymentActions.downloadFileTransaction(
                type,
                transactions,
                transaction?.typePayment,
                transaction?.file[0]?.fileName,
                id,
                reference,
                transaction?.dateProcess,
                transaction?.processedFileData?.validLines,
                transaction?.amount?.currency,
                transaction?.idTransactionStatus,
                transaction?.accountInfo?.shortLabel,
            ),
        );
    };

    const cancelTransaction = () => {
        isCancel.current = true;
        dispatch(
            thirdPaymentActions.summaryThirdPay({
                ...transaction,
                idTransaction: id,
                cancelTransaction: true,
                userId,
            }),
        );
        dispatch(push(`/lotPayments/newPayment/confirm`));
    };

    const RenderWindowingRow = React.memo((props) => {
        // eslint-disable-next-line react/prop-types
        const item = props?.data?.items[props?.index];

        return (
            // eslint-disable-next-line react/prop-types
            <div style={props.style}>
                <GridTable.Container
                    key={`providers-ThirdPayment-item-${id}`}
                    className={!isDesktop && "box box-shadow"}>
                    <VendorsLotPaymentsItem receibedThirdPayment={item} isDesktop={isDesktop} />
                </GridTable.Container>
            </div>
        );
    });

    const RenderRow = (item) => (
        <GridTable.Container key={`providers-ThirdPayment-item-${id}`} className={!isDesktop && "box box-shadow"}>
            <VendorsLotPaymentsItem receibedThirdPayment={item} isDesktop={isDesktop} />
        </GridTable.Container>
    );

    return (
        <Fragment>
            <Notification scopeToShow="detaiThirdParties" />
            <ResponsiveHeader id="detai.thirdParties.title" showLabel>
                <DesktopButtons>
                    {transaction !== null && isPending ? (
                        <Button
                            onClick={() => cancelTransaction()}
                            className="btn btn-outline"
                            bsStyle="link"
                            label="lotPayment.cancel"
                        />
                    ) : (
                        <Button
                            onClick={() => handleDownload("pdf")}
                            className="btn btn-outline"
                            bsStyle="link"
                            image="images/figma/icon/download.svg"
                            label="global.download"
                            loading={fetchingDownload || fetching}
                        />
                    )}
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="global.download" handleClick={() => handleDownload("pdf")} />
                    <Action labelKey="lotPayment.cancel" handleClick={() => cancelTransaction()} />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer showLoader={fetching}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <CustomText className="f-weight-b" textType="data-label" text={`ID: ${id?.substring(0, 8)} `} />
                    <Button className="btn btn-link payments_btn" onClick={handleClickDonload}>
                        {`Archivo: ${transaction?.file[0]?.fileName}`}
                    </Button>
                </div>

                <DataDetailThirdParties
                    paymentType={paymentType() || "-"}
                    debitAccount={transaction?.accountInfo?.shortLabel || "-"}
                    prosesDate={transaction?.dateProcess || "-"}
                    paymentOrders={transaction?.processedFileData?.validLines.toString() || "-"}
                    totalAmont={transaction?.amount?.quantity || "-"}
                    currency={transaction?.amount?.currency || "-"}
                    isDesktop={isDesktop}
                />

                <ProductList
                    fetchingWithPreviousData
                    fetching={fetching}
                    items={_transactions || []}
                    noDataText="global.no.results"
                    noFiltersDataText="debin.global.no.results"
                    isWindowList={needWindowing}
                    renderItem={needWindowing ? RenderWindowingRow : RenderRow}>
                    {(listItem) => (
                        <>
                            <GridTable className="detail-lotpayment-table tablelist underlined">
                                <GridTable.Header>
                                    <GridTable.Container rows={1}>
                                        <TitleColumns />
                                    </GridTable.Container>
                                </GridTable.Header>
                                <GridTable.Body>{listItem}</GridTable.Body>
                            </GridTable>
                            {!transactionLines.lastPage && (
                                <GridTable.Container>
                                    <GridTable.Data columnStart={7} columnWidth={2}>
                                        <Button
                                            bsStyle="link"
                                            onClick={showMoreLogs}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            )}
                        </>
                    )}
                </ProductList>
            </MainContainer>
        </Fragment>
    );
};
DetaiThirdParties.propTypes = {
    isDesktop: bool.isRequired,
};

export default DetaiThirdParties;
